import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpand = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5 7.5L10 12.5L15 7.5",
			stroke: "currentColor",
			strokeWidth: 1.67,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgExpand;
